import CesiumService from "./cesium_service";

export const cesiumService = new CesiumService();